import { api } from './client'

/**
 * 메뉴 뱃지 — 「처리할 게 N건」.
 *
 * 🔴 이상 탐지 뱃지는 **탐지 기능의 유일한 출구**다. 명세 §16-D14 가 보안 알림을
 *   「어드민 인앱 배지로만」 내보내기로 정했고 푸시는 일부러 안 쓴다 (룰 기반 자동 푸시는
 *   §원칙 2 위반). 그런데 이 엔드포인트를 부르는 화면이 없어서, RAPID_TAG·CHAIN_FAILED 를
 *   잡아도 **관리자가 스스로 그 화면을 열기 전에는 아무도 몰랐다.**
 *
 * ⚠ 폴링하지 않는다. 뱃지는 **보고 있을 때만** 값이 있다 — 안 보고 있으면 간격을 줄여도
 *   소용이 없다(푸시를 안 쓰기로 했으므로). 그래서 필요한 건 짧은 간격이 아니라
 *   «창을 다시 볼 때 갱신» 이다. 전역 기본값이 `refetchOnWindowFocus: false` 라
 *   뱃지 쿼리에서만 켠다 (`AppShell`).
 *
 *   숫자로도 그쪽이다 (표준 조직 500명·근무 8시간 기준):
 *   ```
 *   30초 폴링   480,000 요청/일·조직당
 *   화면 전환    약 10,000 요청/일
 *   ```
 *   `server-mtt` 는 min-instances 1 이다.
 */

/**
 * 미해결 이상 탐지 건수 — **ADMIN 전용**.
 *
 * 서버가 두 겹으로 막는다 (`anomaly-alert.routes.ts:20` requireAdmin +
 * 컨트롤러 `ensureAdmin`). 명세 §16-D15 가 보안 알림을 ADMIN 한정으로 못박았다 —
 * 부서장 권한 남용·노사 분쟁 방지다.
 *
 * ⚠ 부르는 쪽에서 `enabled: isAdmin` 을 걸어 **요청 자체를 막는다.** 안 그러면 화면엔
 *   아무것도 없는데 403 만 로그에 쌓이고, 다음 사람이 그 403 을 «정상» 으로 오해한다.
 */
export function getAnomalyBadge() {
  return api<{ count: number }>('/api/anomaly-alerts/badge')
}
